export const getSign = (
  value: number,
  forcedSigned = false,
) => {
  if (forcedSigned && value > 0) {
    return '+';
  }
  return '';
};
